import { storage } from "@unifiedpatents/sso";

export function load(name) {
  return JSON.parse(storage.getItem(name));
}

export function save(name, value) {
  storage.setItem(name, JSON.stringify(value));
}

export function clear(name) {
  storage.removeItem(name);
}
